<template>
  <div>
    <vxe-modal
      v-model="modalIncoming"
      title="Pilih Exbc "
      width="1000"
      height="auto"
      show-zoom
      resize
    >
      <template #default>
        <div class="w-full flex flex-col" @keydown="handleKeydown">
          <div class="flex justify-between flex-col flex-shrink">
            <h3 class="font-semibold">BY UPLOAD EXCEL</h3>
            <div class="flex justify-between">
              <div class="flex gap-2 justify-start">
                <vs-input
                  label="EXCEL FILE"
                  type="file"
                  size="mini"
                  accept=".xlsx"
                  @change="previewFilesModal"
                />
                <div>
                  <el-button
                    @click="exportExcel"
                    icon="el-icon-download"
                    class="mt-base"
                    type="primary"
                    size="mini"
                    >Download Format</el-button
                  >
                </div>
              </div>
              <div>
                <el-input
                  size="mini"
                  class="mt-base"
                  ref="searchInput"
                  autofocus
                  @keyup.enter.native="searchByCodeEnter"
                  placeholder="Search By Code"
                  v-model="searchByCode"
                >
                  <el-button slot="append" icon="el-icon-search"
                /></el-input>
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <vxe-table
            size="mini"
            :loading="loadingTable"
            empty-text="Empty Data"
            keep-source
            border
            show-overflow
            class="mt-5"
            show-header-overflow
            ref="xTableIncoming"
            height="400"
            row-key
            show-footer
            :footer-method="footerMethod"
            :row-style="rowStyle"
            highlight-hover-row
            highlight-current-row
            :row-config="{ isCurrent: true, isHover: true, height: 35 }"
            :column-config="{ resizable: true }"
            :data="dataIncoming"
            :mouse-config="{ selected: true }"
            :checkbox-config="{ highlight: true, range: true }"
            :keyboard-config="{
              isArrow: true,
              isDel: true,
              isEnter: true,
              isTab: true,
              isEdit: true,
            }"
            :edit-config="{
              trigger: 'dblclick',
              mode: 'cell',
              showStatus: true,
            }"
            :scroll-y="{ mode: 'wheel' }"
            @filter-change="changeFilter"
            :tabindex="currentRowIndex"
          >
            <vxe-column type="seq" fixed="left" width="60" />
            <vxe-column
              type="SELECT"
              header-align="left"
              width="120"
              title="SELECT"
            >
              <template #default="{ row }">
                <el-button
                  type="primary"
                  @click="sendData(row)"
                  icon="el-icon-check"
                  size="mini"
                  >{{ $t("select") }}</el-button
                >
              </template>
            </vxe-column>
            <vxe-column
              width="120"
              align="left"
              header-align="center"
              field="kodeBarang"
              :title="$t('code').toUpperCase()"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="200"
              align="left"
              header-align="center"
              field="namaBarang"
              :title="$t('deskripsi').toUpperCase()"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>

            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="satuan"
              :title="$t('satuan').toUpperCase()"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>

            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="tglDokumen"
              title="TGL DOKUMEN"
              :formatter="$$formatDate"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="noUrut"
              :title="$t('noDocs').toUpperCase()"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="idDokumen"
              :title="$t('docsType').toUpperCase()"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="noAju"
              :title="$t('noAju').toUpperCase()"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>

            <vxe-column
              width="150"
              align="left"
              header-align="center"
              field="style"
              :title="$store.state.styleName"
              v-if="$store.state.availableStyle"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="150"
              align="left"
              header-align="center"
              field="color"
              :title="$store.state.colorName"
              v-if="$store.state.availableColor"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="150"
              align="left"
              header-align="center"
              field="size"
              :title="$store.state.sizeName"
              v-if="$store.state.availableSize"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="spec"
              :title="$store.state.specName"
              v-if="$store.state.availableSpec"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="hsCode"
              :title="$t('hsCode').toUpperCase()"
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="150"
              align="right"
              header-align="center"
              field="price"
              :formatter="$$formatAmountBc"
              title="UNIT PRICE"
            >
            </vxe-column>
            <vxe-column
              width="150"
              align="right"
              header-align="center"
              field="currency"
              title="CURRENCY"
            >
            </vxe-column>
            <vxe-column
              width="150"
              align="right"
              header-align="center"
              field="amount"
              :formatter="$$formatAmountBc"
              title="AMOUNT"
            >
            </vxe-column>
            <vxe-column
              fixed="right"
              width="150"
              align="right"
              header-align="center"
              field="qtyBalance"
              :formatter="$$formatAmountBc"
              :title="$t('qty').toUpperCase() + ' BALANCE'"
            >
            </vxe-column>
            <vxe-column
              width="150"
              align="right"
              header-align="center"
              field="qtyInputWh"
              :formatter="$$formatAmountBc"
              :title="$t('qty').toUpperCase() + ' IN'"
            >
            </vxe-column>
          </vxe-table>
          <vxe-form title-align="right" title-width="60">
            <vxe-form-item align="center" span="24">
              <template #default>
                <vxe-button type="reset" @click="modalIncoming = false"
                  >Close</vxe-button
                >
              </template>
            </vxe-form-item>
          </vxe-form>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  props: ["jenis", "dataSelect", "idCek"],

  data() {
    return {
      modalIncoming: false,
      kodeBarang: "",
      loadingTable: false,
      searchByCode: "",
      dataIncoming: [],
      currentRowIndex: 0,
      formatXlsx: [
        { key: "idDokumen", title: "JENIS DOKUMEN" },
        { key: "tglDokumen", title: "TANGGAL DOKUMEN" },
        { key: "noUrut", title: "NO DOKUMEN" },
        { key: "kodeBarang", title: "KODE BARANG" },
        { key: "qty", title: "QTY" },
        { key: "style", title: "STYLE" },
        { key: "color", title: "COLOR" },
        { key: "size", title: "SIZE" },
        { key: "spec", title: "SPEC" },
      ],
      jenisBc: "",
      clickedItem: null,
    };
  },

  methods: {
    async validasiData(data) {
      try {
        const res = await this.$api.post(
          this.$serviceApi + "incoming/bulkforinput",
          data
        );
        if (res.data.status == "validation") {
          return this.notifValidasi(res.data.message, true);
        }
        this.$emit("sendData", res.data.content);
      } catch (error) {
        console.error(error);
      }
    },
    exportExcel() {
      let headers = this.formatXlsx.map((f) => f.title);
      const data = XLSX.utils.aoa_to_sheet([headers]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "Format Upload Exbc.xlsx");
    },
    async previewFilesModal(e) {
      const file = e.target.files[0];
      var reader = new FileReader();
      let dataTable = [];
      try {
        reader.onload = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
          });
          var firstSheet = workbook.SheetNames[0];
          const elements = XLSX.utils.sheet_to_json(
            workbook.Sheets[firstSheet]
          );
          let dataEl = {};
          elements.forEach((el) => {
            this.formatXlsx.forEach((f) => {
              dataEl[f.key] = el[f.title];
            });
            dataTable.push(dataEl);
            // this.tableConfig.tableData.push({
            //   noJurnal: el["NO VOUCHER"],
            //   tanggal: el["TANGGAL"],
            //   kodeAkun: el["KODE AKUN"],
            //   namaAkun: el["NAMA AKUN"],
            //   note: el["NOTE"],
            //   debit: el["DEBIT"],
            //   kredit: el["KREDIT"],
            //   currency: el["CURRENCY"],
            //   rate: el["RATE"],
            //   index: i,
            //   info: "ok",
            // });
          });
          this.validasiData(dataTable);
          // console.log(e);
        };
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.log(error);
      }
    },
    rowStyle({ row }) {
      if (this.dataSelect && this.idCek) {
        let cek = this.dataSelect.some((s) => s[this.idCek] == row.id);
        if (cek) {
          return {
            backgroundColor: "#93e2fa",
          };
        }
      }
    },
    footerMethod({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return "TOTAL";
          }
          if (["qtyBalance", "qtyInputWh"].includes(column.property)) {
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    searchByCodeEnter(e) {
      let data = new Object();

      data.field = "kodeBarang";
      data.datas = [e.target.value];

      this.getIncoming([data]);
    },
    labelStyle() {
      return {
        fontWeight: "1000",
      };
    },

    async changeFilter({ filterList }) {
      this.getIncoming(filterList);
    },
    async getIncoming(filterList) {
      try {
        this.loadingTable = true;
        let dataSearch = {};

        if (filterList && filterList instanceof Array) {
          for (let elm of filterList) {
            dataSearch[elm.field] = elm.datas[0];
          }
        }

        dataSearch.companyCode = this.$store.state.companyCode;
        if (this.kodeBarang) {
          dataSearch.kodeBarang = this.kodeBarang;
        }
        let get = await this.$api.get(this.$serviceApi + "incoming/find", {
          params: dataSearch,
        });
        get.data.content.forEach((elm) => {
          elm.qtyInputWh = !elm.qtyInputWh ? elm.qtyPacking : elm.qtyInputWh;
          elm.qtyBalance = elm.qtyInputWh - (elm.qtyOutWh || 0);
        });
        this.dataIncoming = get.data.content;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingTable = false;
      }
    },

    openModal(kodeBarnag) {
      this.kodeBarang = kodeBarnag;
      this.modalIncoming = true;
      this.currentRowIndex = 0;
      this.getIncoming();
      this.handleAutoFocusToSearchInput();
    },
    closeModal() {
      this.searchByCode = "";
      this.modalIncoming = false;
    },
    async getBarang(jenis) {
      console.log(jenis);
    },
    sendData(row) {
      this.$emit("sendData", row);
    },
    handleKeydown(event) {
      // cek tombol
      if (event.key === "Tab") {
        event.preventDefault();
        if (this.$refs.searchInput) {
          this.$refs.searchInput.blur();
        }
        console.log("tab");
        this.moveToTableRow(); // pindah ke table
      } else if (event.key === "ArrowDown") {
        event.preventDefault();
        if (this.currentRowIndex < this.dataIncoming.length - 1) {
          this.currentRowIndex++;
        }
        const table = this.$refs.xTableIncoming;
        console.log("dkajsndjas");
        table.setCurrentRow(this.dataIncoming[this.currentRowIndex]);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        if (this.currentRowIndex > 0) {
          this.currentRowIndex--;
        }
        const table = this.$refs.xTableIncoming;

        table.setCurrentRow(this.dataIncoming[this.currentRowIndex]);
      } else if (event.key === "Enter") {
        console.log("ENTER");
        event.preventDefault();
        this.triggerSelectOnCurrentRow(); // mendapatkan data current row
      }
    },
    triggerSelectOnCurrentRow() {
      const table = this.$refs.xTableIncoming;
      const currentRow = table.getCurrentRecord();

      if (currentRow) {
        console.log(currentRow);

        this.sendData(currentRow);
      }
    },

    async moveToTableRow() {
      const table = this.$refs.xTableIncoming;
      const totalRows = this.dataIncoming.length;

      this.$nextTick(() => {
        // periksa apakah ada baris berikutnya, jika tidak kembali ke baris pertama
        if (this.currentRowIndex < totalRows - 1) {
          this.currentRowIndex++;
        } else {
          this.currentRowIndex = 0; // kembali ke awal
        }

        // pindahkan ke baris yang sesuai
        table.setCurrentRow(this.dataIncoming[this.currentRowIndex - 1]);
      });
    },
    handleAutoFocusToSearchInput() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          } else {
            console.log("searchInput tidak ditemukan");
          }
        }, 100);
      });
    },
  },
  mounted() {
    this.getIncoming();
    this.handleAutoFocusToSearchInput();
  },
};
</script>
<style></style>
